<template>
  <label
    class="icon__radio-label_container choice-cta"
  >
    <input
      :checked="checked"
      :value="text"
      class="icon__radio-input radio-input"
      type="radio"
    >
    <RadioBorder/>
    <div class="icon__radio-label_wrapper">
      <img
        :src="icon"
        class="icon__radio-label_icon"
      >
      <span
        v-if="text"
        class="icon__radio-label choice"
        v-text="text"
      />
    </div>
  </label>
</template>

<script>
  import RadioBorder from '@/components/RadioBorder';

  export default {
    name: 'ChoiceIcon',
    components: {
      RadioBorder,
    },
    props: {
      text: {
        type: String,
        required: true,
      },
      icon: {
        type: String,
        default: null,
      },
      checked: {
        type: Boolean,
        required: true,
      },
    },
  };
</script>

<style lang="scss">
.icon__radio-label_container {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 75px;
    border: $radio-border-size solid $gray;
    border-radius: $global-border-radius;

    .radio-border-container {
        top: -$radio-border-size;
        left: -$radio-border-size;
        width: calc(100% + #{$radio-border-size} * 2);
        height: calc(100% + #{$radio-border-size} * 2);
    }
}

.icon__radio-label {
    position: relative;
    display: inline-block;
}

.icon__radio-label_wrapper {
    display: flex;
    align-items: center;
    padding-left: 20px;
}

.icon__radio-label_icon {
    width: 50px;
    height: 50px;
    vertical-align: middle;
}

.icon__radio-label_icon + .icon__radio-label {
    margin-left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChoiceIcon.vue